// Manages a keyboard instance's:
// - keys
// - layout manager 

import { useMemo } from "react";
import KeyboardLayoutManager from "../../lib/music/piano/keyboard-layout-manager";

interface UseKeyboardProps {
  height: number;
  range: number;
  startKeyIndex: number;
  width: number;
}

function useKeyboard({height, range, startKeyIndex, width}: UseKeyboardProps) {
  const keys = useMemo(() => {
    const ks = new Array<number>(range);

    let i = 0;
    while (i < range) ks[i] = startKeyIndex + i++;

    return ks;
  }, [startKeyIndex, range]);

  const layoutManager = useMemo(
    () => new KeyboardLayoutManager({keys, canvasDimensions: {height, width}}),
    [keys, height, width]
  );

  return {
    keys,
    layoutManager,
  };
}

export default useKeyboard;
